import React from "react";
import { ButtonGroup } from "mesh-component-library";
import { datadogRum } from "@datadog/browser-rum";

export type ToggleViewProps = {
  changeView: (view: "list" | "map") => void;
  view: "list" | "map";
};

export const ToggleView = ({ changeView, view }: ToggleViewProps) => {
  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    datadogRum.addAction(`[ListView] Changing from ${view} to ${e.target.value}`);
    view === "list" ? changeView("map") : changeView("list");
  };

  return (
    <ButtonGroup
      onChange={handleChange}
      options={[
        {
          defaultChecked: view === "list",
          text: "List View",
          value: "list",
        },
        { defaultChecked: view === "map", text: "Map View", value: "map" },
      ]}
      isFluid
      data-testid="toggleView"
    />
  );
};
